import DIApi from './_diApi';

class AccountTransferAPI extends DIApi {
  controllerName = 'AccountTransfers';
}

export default new AccountTransferAPI();
